export const wcApiUrl = (env) => ({
  REACT_APP_GA_TRACKING_ID: {
    dev: 'UA-8554016-25',
    qa: 'UA-8554016-25',
    prod: 'UA-8554016-24',
  },
  REACT_APP_GTM_ID: {
    dev: 'GTM-P64TT4Q',
    qa: 'GTM-P64TT4Q',
    prod: 'GTM-W5FHS94',
  },
  REACT_APP_TOKEN_SERVICE_URL: `https://api-dt-${env}.orientalbank.com/dsasync/auth/token`,
  REACT_APP_CLIENT_ID: {
    dev: '31ge8hs2q4vad9epsuri66n42i',
    qa: '6dc6mfubliljg3a0oai80241dt',
    staging: '294dgno4tvkdrj0boh1tep0c4l',
    prod: '6cm90n39d0h59gigduubpgn7ts',
  },
  REACT_APP_PRODUCT_QUESTIONS_TRANSLATION_URL: `https://api-dt-${env}.orientalbank.com/dsreference/data?path=i18n`,
  REACT_APP_PRE_SIGNED_URL: `https://api-dt-${env}.orientalbank.com/dsreference/preSignedUrl?path=`,
  REACT_APP_CUSTOMER_VALIDATION: `https://api-dt-${env}.orientalbank.com/dsverification/customer/customer-validation`,
  REACT_APP_EXPRESS_FLOW_USERNAME: `https://api-dt-${env}.orientalbank.com/ob-idmapi/authentication/username`,
  REACT_APP_SAVE_SUBMIT_APPLICATION_URL: `https://api-dt-${env}.orientalbank.com/dsaccounts/application/commonAuth/save`,
  REACT_APP_EXPRESS_FLOW_OTPCHOICE: `https://api-dt-${env}.orientalbank.com/ob-idmapi/authentication/otpchoice`,
  REACT_APP_EXPRESS_FLOW_PASSWORD: `https://api-dt-${env}.orientalbank.com/ob-idmapi/authentication/password`,
  REACT_APP_EXPRESS_ELIGIBILITY: `https://api-dt-${env}.orientalbank.com/dsverification/etb-express/express/validation`,
  REACT_APP_ADDRESS_LOOKUP_URL: `https://api-dt-${env}.orientalbank.com/dsverification/address/lookup`,
  REACT_APP_MOBILE_URL: `https://api-dt-${env}.orientalbank.com/dsverification/phone/validation`,
  REACT_APP_EMAIL_VERIFICATION_URL: `https://api-dt-${env}.orientalbank.com/dsverification/email/validation`,
  REACT_APP_AGE_RULE_URL: `https://api-dt-${env}.orientalbank.com/dsrules/rules/commonAuth/application`,
  REACT_APP_GET_CONSENT_URL: `https://api-dt-${env}.orientalbank.com/dsreference/data?path=`,
  REACT_APP_AUTOMATED_FLOW_URL: `https://api-dt-${env}.orientalbank.com/dsaccounts/application/automatedflow/status`,
  REACT_APP_PING_URL: `https://api-dt-${env}.orientalbank.com/dsasync/ping`,
  REACT_APP_GET_FUNDING_ORIENTAL_URL: `https://api-dt-${env}.orientalbank.com/dsaccounts/application/funding/accounts`,
  REACT_APP_GET_LINKTOKEN_URL: `https://api-dt-${env}.orientalbank.com/plaid/link-token`,
  REACT_APP_ACCOUNT_VALIDATION: `https://api-dt-${env}.orientalbank.com/dsverification/account/account-validation`,
  REACT_APP_DOCUMENT_UPLOAD_URL: `https://api-dt-${env}.orientalbank.com/dsdocument/commonAuth/upload`,
  REACT_APP_DOCUMENT_UPLOAD_XL_URL: `https://api-dt-${env}.orientalbank.com/dsdocument/commonAuth/uploadxl`,
  REACT_APP_GET_EXCHANGETOKEN_URL: `https://api-dt-${env}.orientalbank.com/dsaccounts/plaid/exchangeTokenAndAuth`,
  REACT_APP_CD_TERMS_AND_CONDITIONS: `https://api-dt-${env}.orientalbank.com/dsaccounts/cdAutomated/status?applicationId=`,
  REACT_APP_CD_TERMS_AND_CONDITIONS_TEXT: `https://api-dt-${env}.orientalbank.com/dsreference/data?path=consents`,
  REACT_APP_CD_INTEREST_PLAN_DETAILS: `https://api-dt-${env}.orientalbank.com/dsaccounts/application/getDRPRIntPlanDetails`,
  REACT_APP_GET_CONTRIBUTION_YEAR: `https://api-dt-${env}.orientalbank.com/dsverification/customer/getMaximumDepositAmount`,
});

// event to redirect the user from web component to dashboard.
export const handleBacktoAccount = () => {
  window.dispatchEvent(
    new CustomEvent('goto-account', {
      bubbles: true,
      composed: true,
    })
  );
};

export const openLinkOrDownloadWithoutIsSafeUrl = (url, filename) => {
  try {
    if (typeof window !== 'undefined' && window.cordova && window.cordova.InAppBrowser) {
      // Open in system browser to trigger download
      window.cordova.InAppBrowser.open(url, '_system');
      // window.cordova.InAppBrowser.open(`${url}?ts=${Date.now()}`, '_blank', 'location=yes');
    } else if (filename) {
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.rel = 'noopener';
      link.target = '_blank';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      // Fallback for non-Cordova environments
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  } catch (e) {
    // Final fallback
    window.location.href = url;
  }
};

export const webComponentBaseUrl = (env) => {
  const baseUrl = `https://ds-ui-assets${env === 'prod' ? `` : `-${env}`}.orientalbank.com`;
  return baseUrl;
};

// utils/popperUtils.js (or utils/wcFlowUtils.js)

/**
 * Resolves the Shadow Root container for MUI Popper components
 * when rendered inside a Web Component (Shadow DOM).
 *
 * Use this with React.useMemo() in any component that renders
 * a MUI Popper (Autocomplete, DatePicker, Select, etc.)
 *
 * @param {boolean} isWcFlow - Whether the app is running as a web component
 * @param {React.RefObject} hostRef - Ref attached to the component inside Shadow DOM
 * @returns {ShadowRoot | undefined} - Shadow root as portal target, or undefined for regular web flow
 */
export const getShadowRootContainer = (isWcFlow, hostRef) => {
  if (!isWcFlow) return undefined;
  const root = hostRef?.current?.getRootNode?.();
  return root instanceof ShadowRoot ? root : undefined;
};
